
export class PCodeConfig
{
	static azureAd: PCodeConfigAzureAd =
		{
			tenantId: '',
			clientId: ''
		}

	static vapid: PCodeConfigVapid =
		{
			publicKey: 'BKs-gr4Ax565YXCxSgqOvO9O19zQUG_P5vAz_bfhiamTRQNqFeT1wUtHX4cL4JX3oG8x8HCo5P0pIYzmOZ3eitQ'
		}
}

interface PCodeConfigAzureAd
{
	tenantId: string;
	clientId: string;
}
interface PCodeConfigVapid
{
	publicKey: string;
}